import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import SmartIndexLayout from 'layouts/crud/SmartIndexLayout'
import ViewDomainSmartview
  from 'widgets/smartviews/domains/ViewDomainSmartview'
import CreateDomainSmartview
  from 'widgets/smartviews/domains/CreateDomainSmartview'
import Delete from 'support/actions/Delete'
import DomainInfoColumns from 'widgets/domains/DomainInfoColumns'

export default class Index extends CrudPageContent {
  get resourceName () {
    return 'domains'
  }

  get layout () {
    return SmartIndexLayout
  }

  get filters () {
    return (
      <>
        <Filters.SearchFilter />
        <Filters.EnumFilter name='status' enum='domain_status' placeholder='Vælg status' />
      </>
    )
  }

  get columns () {
    return (
      <>
        <DomainInfoColumns />
        <Columns.DenominationCurrency name='price' label='Stk. Pris' />
        <Columns.Enum enum='domain_status' name='status' />
      </>
    )
  }

  get actions () {
    return (
      <>
        <Delete />
      </>
    )
  }

  renderAfterCrud () {
    return null
  }

  get crudProps () {
    return {
      ...super.crudProps,
      createLabel: 'Opret domæne',
      createSmartview: <CreateDomainSmartview />,
      smartview: <ViewDomainSmartview />
    }
  }
}
